export const pageBackground = "#0f172a";
export const tileBackground = "#1e293b";
const blue = "#38bdf9";
const purple = "#7c3aed";
const green = "#52c41a";
const orange = "#ffae38";
const gray = "#d1d5db";
const red = "#f472b6";

export const palette = [blue, purple, green, orange, gray, red];
